module.exports = __webpack_public_path__ + "img/矩形 6.0cd424e3.png";